export const selectedWorks = [
   {
    title: "PhysicsX Platform",
    date: "January 2025",
    tech: [
      "React",
      "Typescript",
      "Python",
      "C++",
      "LangChain",
      "Postgres",
      "Kubernetes",
      "AWS",
    ],
    description:
      "The AI-native engineering platform for industrial design and simulation. I work across the full stack — React/TypeScript frontend, Python and C++ services, and LLM tooling — running on Kubernetes and AWS.",
    link: "https://www.physicsx.ai/platform",
  },
  {
    title: "Syntensor",
    date: "February 2021",
    tech: [
      "React",
      "Redux",
      "d3.js",
      "Canvas",
      "Python",
      "Typescript",
      "Node.js",
      "MySQL",
      "ElasticSearch",
      "AWS",
      "Cypress",
    ],
    description:
      "A drug-discovery platform for analysing the predictions of an ML model that forecasts how drug candidates affect human biology.",
    link: "https://syntensor.com",
  },
  // {
  //   title: "Torchdyn",
  //   date: "August 2022",
  //   tech: ["Next.js", "React", "WebGL"],
  //   description:
  //     "A microsite for a deep learning Python library and scientific computing.",

  //   link: "https://torchdyn.org",
  // },
  {
    title: "Uproar Tools",
    date: "February 2019",
    tech: ["Django", "Python", "Selenium", "Postgres", "React", "d3.js", "AWS"],
    description:
      "A digital tool to help civil society advocate and lobby for digital rights at the United Nations. ",
    link: "https://tools.uproar.fyi",
  },
  {
    title: "Reimagine the game",
    date: "August 2018",
    link: "https://www.informationisbeautifulawards.com/showcase/3442-reimagine-the-game",
    tech: [
      "React",
      "Redux",
      "d3.js",
      "Canvas",
      "WebGL",
      "Tensorflow.js",
      "Node.js",
    ],
    description:
      "Award-winning data-driven microsite telling the story of FC Bayern matches through thousands of data points from key moments in each game.",
  },
  {
    title: "Electric Insights",
    date: "June 2017",
    tech: [
      "React",
      "Redux",
      "d3.js",
      "Mocha",
      "Chai",
      "Express",
      "Node.js",
      "MongoDB",
    ],
    description:
      "An interactive visualization of the real-time breakdown of the electricity production in the UK.",
    link: "https://electricinsights.co.uk",
  },
  {
    title: "The Our World in Data - Grapher",
    date: "February 2015",
    tech: ["Backbone", "d3.js", "SVG", "PHP", "Mysql"],
    description: "Open-source tool to store and visualize data.",
    link: "https://ourworldindata.org/owid-grapher",
  },
  {
    title: "Czech Crime Map",
    date: "November 2013",
    tech: ["d3.js", "SVG", "PHP", "Mysql"],
    description: "An interactive map of crime in the Czech Republic.",
    link: "https://czechcrime.org/",
  },
];

export const experiences = [
  {
    date: "2024 - present",
    title: "Staff Product Engineer",
    description: "PhysicsX",
  },
  {
    date: "2021 - 2024",
    title: "Founding Product Engineer",
    description: "Syntensor",
  },
  {
    date: "2018 - 2021",
    title: "Contract Senior Full-Stack Developer",
    description: "Independent (own Ltd company)",
  },
  {
    date: "2016 - 2018",
    title: "Lead Full-Stack Developer",
    description: "The Economist Group/Signal Noise",
  },
  {
    date: "2015",
    title: "Research Assistant",
    description: "University of Oxford",
  },
  {
    date: "2008 - 2015",
    title: "Founder and Full-Stack Developer",
    description: "Geographics",
  },
  {
    date: "2010 - 2012",
    title: "Flash developer",
    description: "SYMBIO Digital",
  },
];

export const awards = [
  {
    date: "2018",
    title: "Reimagine the game",
    description: "KANTAR - Information Is Beautiful Awards",
    link: "https://www.informationisbeautifulawards.com/showcase/3442-reimagine-the-game",
  },
  {
    date: "January 2014",
    title: "Czech Crime Map",
    description: "On Think Tanks - data viz competition",
  },
  {
    date: "October 13, 2013",
    title: "Victorinox Festival Ready",
    description: "THE FWA Mobile SITE OF THE DAY",
    link: "https://thefwa.com/cases/victorinox-festival-ready",
  },
  {
    date: "May 3, 2013",
    title: "The Packing Battle",
    description: "THE FWA SITE OF THE DAY",
    link: "https://thefwa.com/cases/packing-battle",
  },
  {
    date: "January 10, 2012",
    title: "The Trip Around The Globe",
    description: "THE FWA SITE OF THE DAY",
    link: "https://thefwa.com/cases/trip-around-the-globe?month=2012-01",
  },
];

export const speaking = [
  {
    title: "Datapoints are people too",
    date: "April 2021",
    description: "Outlier 2021 conference panel discussion",
    link: "https://www.youtube.com/watch?v=qCSplKHJAWk",
  },
  {
    title: "Machine learning in Javascript (workshop)",
    date: "December 2020",
    description: "Datafest 2020 in Tbilisi",
    link: "https://www.youtube.com/watch?v=1IfhKXiOhHw",
  },
  {
    title: "Engaged and Outraged",
    date: "November 2019",
    description: "Datafest 2019 in Tbilisi",
    link: "https://vimeo.com/464601186",
    presentationLink: null,
  },
  {
    title: "Spot fake Instagram profiles with TensorFlow.js",
    date: "November 2019",
    description: "AI Javascript London meet-up",
    link: null,
    presentationLink: null,
  },
  {
    title: "Quick and easy way to add AI to your CV",
    date: "September 2019",
    description: "JSDayIE in Dublin",
    link: null, // Assuming no recording available
    presentationLink: null,
  },
  {
    title: "Machine Learning in Javascript",
    date: "February 2019",
    description: "Applied AI conference in London",
    link: "https://vimeo.com/330347293",
    presentationLink: null,
  },
  {
    title: "Getting Started with TensorFlow.js",
    date: "February 2019",
    description: "AI Javascript London meet-up",
  },
  {
    title: "Visualisation with human touch",
    date: "May 2017",
    description: "Visualising Data London",
    link: null,
    presentationLink: null,
  },
  {
    title: "Mapping crime",
    date: "April 2014",
    description:
      " Data visualisations: Where data, design and technology meet politics",
    link: null,
    presentationLink: null,
  },
  {
    title: "Drugs, Guns and Sex",
    date: "February 2014",
    description: "CartoCon in Olomouc",
    link: "https://vimeo.com/87926507",
    presentationLink: null,
  },
  // Add more engagements as needed
];

export const writing = [
  {
    title: "Why you should run your dev team like the Swedish Air Force",
    date: "February 2024",
  },
  {
    title: "No-nonsense advice on public speaking",
    date: "January 2024",
    link: "https://medium.com/@zdenekhynek/no-nonsense-advise-on-public-speaking-9fb8684ed6d3",
  },
  {
    title: "10 easy steps to make a perfect software estimate",
    date: "June 2020",
    link: "https://medium.com/@zdenekhynek/10-easy-steps-to-make-a-perfect-software-estimate-8dd4762f4153",
  },
  {
    title: "Prototyping for digital rights lobbying",
    date: "April 2019",
    link: "https://medium.com/thinking-out-loud/prototyping-for-digital-rights-lobbying-9e011dccff24",
  },
  {
    title:
      "How I’ve spent a week learning Tensorflow.js so that I could put it on my CV",
    date: "March 2019",
    link: "https://medium.com/@zdenekhynek/how-ive-spent-a-week-learning-tensorflow-js-so-that-i-could-put-it-on-my-cv-8964ffcb9fc1",
  },
  {
    title:
      "Five talks from OpenVis 2017 you’d be completely insane not to watch right now",
    date: "June 2017",
    link: "https://medium.com/@zdenekhynek/openvis-2017-review-cc2c5ad89891",
  },
];

export const reading = [
  {
    title: "The Pragmatic Programmer",
    date: "February 2024",
    link: "",
  },
  {
    title: "Designing Products People Love by Scott Hurff",
    date: "January 2024",
    link: "https://galvanized-swordfish-aa0.notion.site/Designing-products-that-people-want-cfdb3879c6894b8e96219165ed034bfa?pvs=4",
  },
  {
    title: "A Philosophy of Software Design by John Ousterhout",
    date: "December 2023",
    link: "https://galvanized-swordfish-aa0.notion.site/A-Philosophy-of-Software-Design-b0d028f024614408b98b4dccbb67c273?pvs=4",
  },

  {
    title: "Designing Data-Intensive Applications",
    date: "2023",
    link: "",
  },
];
